export function buildHeader(tab) {
    const header = tab === 'current-rr-tab' ?
        ['% of Sq Ft', 'Start', 'End', 'Current Monthly Rent', 'Current Annual Rent', 'PSF', 'Escalation Date', 'Escalation Monthly Rent',
            'Months at Current Rent', 'Months at Escalation Rent', 'Annual Effective Rent', 'Option(s)', 'Option #1 Rent', 'Option #2 Rent',
            'Option #3 Rent', 'Option #4 Rent', 'Option #5 Rent', 'Notes']
        :
        ['% of Sq Ft', 'Start', 'End', 'Monthly Rent', 'Annual Rent', 'PSF', 'TI/SF', 'LC (%)', 'TI Total', 'LC Total', 'Escalation Date', 'Escalation Monthly Rent',
            'Months at Current Rent', 'Months at Escalation Rent', 'Annual Effective Rent', 'Option(s)', 'Option #1 Rent', 'Option #2 Rent',
            'Option #3 Rent', 'Option #4 Rent', 'Option #5 Rent', 'Notes'];
    return {
        headerRow: header,
        rows: {'no-row': {valueCells: []}}
    }
}